export default __webpack_public_path__ + "static/media/sostenible.60d2709f.svg";